import { CradleOutlineIcon } from './CradleOutlineIcon';

/**
 * author: Google
 * id 3CDAD9E8-C4DC-42CA-9262-A0C45B94B139
 * name cradle-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cradle-outline.svg
 * tags
 * - People / Family 
 * - Home Automation 
 */
export const BabyRoomOutlineIcon = CradleOutlineIcon;
export default BabyRoomOutlineIcon